import { render, staticRenderFns } from "./BundleSmall.vue?vue&type=template&id=8579ce18&"
import script from "./BundleSmall.vue?vue&type=script&lang=js&"
export * from "./BundleSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports